<template>
    <BaseCard theme="muted" padding="lg" class="new-home-card">
        <div class="flex flex-col gap-4">
            <!-- Top: Title and CTA button -->
            <div class="flex items-center justify-between gap-4">
                <h3 class="title-section text-ink">Keep the Momentum Going</h3>
                <BaseButton theme="neutral" class="shrink-0" @click="handleWrappedClick">View</BaseButton>
            </div>
            <p class="body-small text-ink-muted">Discover 3 things you didn't know about yourself</p>
        </div>
    </BaseCard>
</template>

<script setup>
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import { openUrl } from "~vue/utils";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { onMounted } from "vue";

const { wrappedUrl, cardType, wrappedYear } = defineProps({
    wrappedUrl: { type: String, default: "/wrapped/" },
    cardType: { type: String, required: true },
    wrappedYear: { type: Number, required: true },
});

const handleWrappedClick = () => {
    logUserInteraction(AmplitudeEventNames.HOMEPAGE_WRAPPED_REVIEWED_CARD_CLICKED, { year: wrappedYear });
    openUrl(wrappedUrl);
};

onMounted(() => {
    logUserInteraction(AmplitudeEventNames.HOMEPAGE_CARD_SHOWN, { card_type: cardType });
});
</script>
